import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../context/AuthContext';
import axios from "axios";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { API_BASE_URL } from "../../../../Helpers/apiConfig";

function SchoolEditTeacher() {
    const { t } = useTranslation()
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [passwordMsg, setPasswordMsg] = useState([]);
    const params = useParams();
    const [data, setData] = useState([]);
    const [classes, setClasses] = useState([]);
    const [initialClassId, setInitialClassId] = useState("");
    const [selectedClassId, setSelectedClassId] = useState("");

    const headers = () => ({
        "accept": "*/*",
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'false',
        'Authorization': 'Bearer ' + user.token
    });

    const syncLecturerClass = async () => {
        if (String(selectedClassId) === String(initialClassId)) return;

        const teacherId = Number(params["id"]);

        if (initialClassId) {
            const oldClass = classes.find(c => String(c.id) === String(initialClassId));
            if (oldClass) {
                await axios({
                    method: 'Put',
                    url: `${API_BASE_URL}/manager/EditSchool/UpdateClass`,
                    data: { ...oldClass, lecturerId: 0 },
                    headers: headers()
                });
            }
        }

        if (selectedClassId) {
            const newClass = classes.find(c => String(c.id) === String(selectedClassId));
            if (newClass) {
                await axios({
                    method: 'Put',
                    url: `${API_BASE_URL}/manager/EditSchool/UpdateClass`,
                    data: { ...newClass, lecturerId: teacherId },
                    headers: headers()
                });
            }
        }
    }

    const onSumbit = async (e) => {
        e.preventDefault();
        try {
            let url = `${API_BASE_URL}/manager/EditSchool/UpdateLecturer`;
            await axios({
                method: 'Put',
                url: url,
                // Sadece düzenlenebilir alanlar gönderilir; backend geri kalanını kayıttan korur (G13).
                data: {
                    id: data.id,
                    username: document.getElementById("username").value,
                    fullName: document.getElementById("fullName").value,
                    userNote: data.userNote
                },
                headers: headers()
            }).then(async res => {
                if (res.status === 200) {
                    console.log(res.data);
                    if (res.data['success']) {
                        await syncLecturerClass();
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`,
                            timer: 3000,
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                    else {
                        setMsg(res.data['message']);
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            confirmButtonText: `Tamam`,
                            timer: 3000,
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err?.message || "Bir hata oluştu");
        }
    }

    const onPasswordSubmit = async (e) => {
        e.preventDefault();
        const newPassword = document.getElementById("newPassword").value;
        const newPasswordVerify = document.getElementById("newPasswordVerify").value;
        if (!newPassword || newPassword !== newPasswordVerify) {
            setPasswordMsg("Şifreler eşleşmiyor.");
            return;
        }
        try {
            await axios({
                method: 'Put',
                url: `${API_BASE_URL}/manager/EditSchool/UpdateLecturerPassword`,
                params: {
                    lecturerId: data.id,
                    newPassword: newPassword
                },
                headers: headers()
            }).then(res => {
                console.log(res.data);

                if (res.status === 200 && res.data['success']) {
                    Swal.fire({
                        title: "Şifre Güncellendi!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    });
                    document.getElementById("newPassword").value = "";
                    document.getElementById("newPasswordVerify").value = "";
                }
                else {
                    setPasswordMsg(res.data['message'] || "Beklenmedik Bir Hata Oluştu.");
                }
            });
        } catch (err) {
            alert("Şifre güncellenirken bir hata oluştu. Lütfen tekrar deneyiniz.");
            setPasswordMsg(err.message);
        }
    }

    useEffect(() => {
        (async () => {
            try {
                let url = `${API_BASE_URL}/manager/EditSchool/GetLecturerById`;
                await axios({
                    method: 'GET',
                    url: url,
                    params: {
                        lecturerId: params["id"]
                    },
                    headers: headers()
                }).then(res => {
                    if (res.status === 200) {
                        setData(res.data['data'])
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            } catch (err) {
                setMsg(err?.message || "Bir hata oluştu");
            }

            try {
                let url = `${API_BASE_URL}/manager/EditSchool/GetClasses`;
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headers()
                }).then(res => {
                    if (res.status === 200 && res.data['success']) {
                        const classList = res.data['data'];
                        setClasses(classList);
                        const current = classList.find(c => String(c.lecturerId) === String(params["id"]));
                        const currentId = current ? String(current.id) : "";
                        setInitialClassId(currentId);
                        setSelectedClassId(currentId);
                    }
                });
            } catch (err) {
                setMsg(err?.message || "Bir hata oluştu");
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div>
            <br />
            <div className="card">
                <div className="card-header d-flex justify-content-center">
                    <h2> {t('editteacher')} </h2>
                </div>
                <div className="card-body">
                    <form onSubmit={onSumbit}>
                        <br />
                        <h4> {msg} </h4>
                        <h5> {t('userId')} : {data.id}</h5>
                        <div class="mb-3">
                            <label for="username" class="form-label">{t('email')}</label>
                            <textarea type="email" class="form-control" name="username" id="username" defaultValue={data.username} />
                        </div>
                        <div class="mb-3">
                            <label for="fullName" class="form-label"> {t('namesurname')} </label>
                            <textarea class="form-control" name="fullName" id="fullName" defaultValue={data.fullName} />
                        </div>
                        <div class="mb-3">
                            <label for="classId" class="form-label">Sorumlu Olduğu Sınıf</label>
                            <select id="classId" class="form-select" value={selectedClassId} onChange={(e) => setSelectedClassId(e.target.value)}>
                                <option value="">Sınıf Atanmadı</option>
                                {classes.map((c) => (
                                    <option key={c.id} value={c.id}>{c.className}</option>
                                ))}
                            </select>
                        </div>
                        <div className="d-flex justify-content-center">
                            <button type="submit" class="btn btn-primary">{t("update")}</button>
                        </div>
                    </form>
                </div>
                <div className="card-footer">

                </div>
            </div>

            <br />

            <div className="card">
                <div className="card-header d-flex justify-content-center">
                    <h2>Şifre Güncelle</h2>
                </div>
                <div className="card-body">
                    <form onSubmit={onPasswordSubmit}>
                        <h5 className="text-danger">{passwordMsg}</h5>
                        <div class="mb-3">
                            <label for="newPassword" class="form-label">Yeni Şifre</label>
                            <input type="password" class="form-control" id="newPassword" />
                        </div>
                        <div class="mb-3">
                            <label for="newPasswordVerify" class="form-label">Yeni Şifre (Tekrar)</label>
                            <input type="password" class="form-control" id="newPasswordVerify" />
                        </div>
                        <div className="d-flex justify-content-center">
                            <button type="submit" class="btn btn-primary">Şifreyi Güncelle</button>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    );
}

export default SchoolEditTeacher;
